<template>
<div>

    <van-popup position="bottom" v-model="showTreaty" @click-overlay='close' :duration=".1">
        <div class="fxtreaty">
            <h2>烽行体育用户协议</h2>
            <div class="treaty"><TreatyMini /></div>
            <div class="btmbtn" @click="close">确定</div>
        </div>
    </van-popup>

</div>
</template>

<script>
    import TreatyMini from './treaty_mini'
    // import {mapGetters} from "vuex";
    export default {
        name: "treatypop",
        // computed: mapGetters(['showTreaty']),
        // props:  ['showTreaty'],
        components: {
            TreatyMini
        },
        data() {
            return {
                showTreaty: true
            }
        },
        methods: {
            close(){
                this.$store.commit('HIDE_TREATY')
            }
        }
    }
</script>

<style scoped>
    .van-popup{background: none;}
</style>
